import { fromJS } from 'immutable';

import Router from './utils/Router';
import { setRoute } from './modules/routes/actions/set';

import routes from './routes.json';
import aliases from './aliases.json';

import store from './store';

function mapAdditionalRouting(state) {
    let additional = {};

    for (let [ key, value ] of state.entries()) {
        if (key !== 'global' && value) {
            additional[key] = {
                value: value.get('value')
            };

            let params = value.get('parameters');

            if (params && params.size) {
                additional[key].parameters = params.toJS();
            }
        }
    }

    return additional;
}

function onChange(route, parameters) {
    const state = store.getState().routes,
        global = state.get('global');

    if (route.substr(0, 7) === 'global:') {
        route = route.substr(7);
    }

    let additional = {},
        params = {};

    Object.keys(parameters).forEach(param => {
        if (param.charAt(0) === '*') {
            if (param.substr(-11) === '.parameters') {
                let name = param.substr(1, param.length - 12);

                if (!additional[name]) {
                    additional[name] = { value: null };
                }

                try {
                    additional[name].parameters = JSON.parse(parameters[param]);
                } catch (e) {
                }
            } else {
                let name = param.substr(1);

                if (!additional[name]) {
                    additional[name] = { value: null };
                }

                additional[name].value = parameters[param];
            }
        } else {
            params[param] = parameters[param];
        }
    });

    if (!global || global.get('value') !== route || !global.get('parameters').equals(fromJS(params))) {
        store.dispatch(setRoute('global:' + route, params));
    }

    Object.keys(additional).forEach(name => {
        let rParameters = additional[name].parameters,
            value = additional[name].value,
            r = state.get(name);

        if (!r || r.get('value') !== value || !r.get('parameters').equals(fromJS(rParameters))) {
            store.dispatch(setRoute(name + (value ? ':' + value : ''), rParameters));
        }
    });
}

function onAlias(route, parameters) {
    store.dispatch(setRoute(route, parameters));
}

const router = new Router(routes, aliases, '/trading', onChange, onAlias);

store.subscribe(() => {
    const state = store.getState().routes;

    let route = state.get('global'),
        name = route && route.get('value'),
        parameters = route && route.get('parameters').toJS();

    let additional = mapAdditionalRouting(state);

    Object.keys(additional).forEach(r => {
        parameters['*' + r] = additional[r].value;

        if (additional[r].parameters) {
            parameters['*' + r + '.parameters'] = JSON.stringify(additional[r].parameters);
        }
    });

    router.setRoute('global:' + name, parameters);
});

export default router;
